import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import BenefitCard from './club/BenefitCard';
import { RedeemModals } from './club/RedeemModals';
import useRedeemBenefit from '../hooks/useRedeemBenefit';
import { getRewardTerms, isRewardLive, sortCatalog, usableRewards } from '../utils/loyalty';

const categories = [
  { id: 'all', label: 'Todos' },
  { id: 'producto', label: 'Productos' },
  { id: 'descuento', label: 'Promos' },
  { id: 'experiencia', label: 'Experiencias' },
  { id: 'servicio', label: 'Servicios' },
];

const ClubRewards = ({ userPoints = 0, refreshUserProfile, setCurrentView, isLoggedIn }) => {
  const [beneficios, setBeneficios] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const redeem = useRedeemBenefit({
    userPoints,
    refreshUserProfile,
    onNeedLogin: isLoggedIn ? undefined : () => setCurrentView('login'),
  });

  useEffect(() => {
    const fetchBeneficios = async () => {
      try {
        const snap = await getDocs(collection(db, 'beneficios'));
        setBeneficios(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch {
        setBeneficios([]);
      }
    };
    fetchBeneficios();
  }, []);

  const live = sortCatalog(beneficios.filter((b) => isRewardLive(b)));
  const filtered = selectedCategory === 'all'
    ? live
    : live.filter((r) => (r.category || '').toLowerCase() === selectedCategory);
  const todayCount = usableRewards(live, userPoints).length;

  return (
    <div className="px-4 py-6 pb-10 max-w-3xl mx-auto">
      <p className="text-sm text-gray-500">Tus puntos</p>
      <p className="text-4xl font-black tabular-nums text-maja-red">{Number(userPoints || 0).toLocaleString('es-AR')}</p>
      <h1 className="text-2xl font-black mt-4">Canjes</h1>
      <p className="text-sm text-gray-500 mt-1">
        Cada beneficio se usa con puntos más un importe en el local.
        {todayCount > 0 ? ` Hoy podés usar ${todayCount}.` : ''}
      </p>

      <div className="flex flex-wrap gap-2 mt-5 mb-5">
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => setSelectedCategory(cat.id)}
            className={`h-10 px-4 rounded-full text-sm font-black ${
              selectedCategory === cat.id ? 'bg-maja-red text-white' : 'bg-gray-100 text-gray-700'
            }`}
          >
            {cat.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {filtered.length === 0 && (
          <p className="col-span-full text-sm text-gray-500 py-8">No hay beneficios disponibles.</p>
        )}
        {filtered.map((reward, i) => {
          const can = isLoggedIn && userPoints >= getRewardTerms(reward).puntos;
          return (
            <BenefitCard
              key={reward.id}
              reward={reward}
              index={i}
              cta={!isLoggedIn ? 'Iniciar sesión' : can ? 'Usar beneficio' : 'Te faltan puntos'}
              onAction={() => {
                if (!isLoggedIn) setCurrentView('login');
                else if (can) redeem.start(reward);
              }}
            />
          );
        })}
      </div>
      {redeem.error && !redeem.open && (
        <p className="mt-4 text-center font-extrabold text-maja-red">{redeem.error}</p>
      )}
      <RedeemModals {...redeem} />
    </div>
  );
};

export default ClubRewards;
